var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconLogoNaver = function SvgIconLogoNaver(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.573 22.5h20.854a.072.072 0 0 0 .073-.073V1.573a.072.072 0 0 0-.073-.073H1.573a.072.072 0 0 0-.073.073v20.854c0 .04.032.073.073.073Zm12.29-10.451V6.631h3.997v10.738h-4.01l-3.712-5.418v5.418H6.14V6.631h4.012l3.71 5.418Z",
    fill: "#A4A7AD"
  })));
};
export default SvgIconLogoNaver;